export enum PricingVariant {
  Default = 'default',
  Featured = 'featured',
  Spaced = 'spaced',
}

export enum CurrencySymbol {
  Dollar = '$',
  Euro = '€',
  Peso = '₱',
  Pound = '£',
}
